import { Type } from "@scalar/typebox";
const exampleBodyMime = [
  "application/json",
  "text/plain",
  "text/html",
  "application/javascript",
  "application/xml",
  "application/yaml",
  "application/edn",
  "application/octet-stream",
  "application/x-www-form-urlencoded",
  "multipart/form-data",
  /** Used for direct files */
  "binary"
];
const xScalarFileValueSchema = Type.Union([
  Type.Object({
    url: Type.String(),
    base64: Type.Optional(Type.String())
  }),
  Type.Null()
]);
const xScalarExampleBodySchema = Type.Object({
  encoding: Type.Union(exampleBodyMime.map((it) => Type.Literal(it))),
  content: Type.Union([Type.Record(Type.String(), Type.Any()), Type.String()]),
  file: Type.Optional(xScalarFileValueSchema)
});
const xScalarExampleParameterSchema = Type.Optional(Type.Record(Type.String(), Type.String()));
const xScalarClientConfigRequestExampleSchema = Type.Partial(
  Type.Object({
    name: Type.String(),
    body: xScalarExampleBodySchema,
    parameters: Type.Object({
      path: xScalarExampleParameterSchema,
      query: xScalarExampleParameterSchema,
      header: xScalarExampleParameterSchema,
      cookie: xScalarExampleParameterSchema
    })
  })
);
export {
  exampleBodyMime,
  xScalarClientConfigRequestExampleSchema
};
//# sourceMappingURL=x-scalar-client-config-request-example.js.map
